import Header from './Header'

export default function Layout({ children }) {
  return (
    <div className={`custom-theme`}>
      <Header />
      <div className="body-main">{children}</div>
    </div>
  )
}